import ItemView from "../../components/ItemView/ItemView.vue"
import {
    updateLicenceInformation,
} from "./actions";

export default [{
    "path": "/Licences",
    "component": { ...ItemView },
    "name": "Licences, Ratings and Medical",
    "meta": {
        "app": "ftc",
        "name": "Licences, Ratings and Medical",
        "sideNav": true,
        "sideNavSection": "Pilot Data",
        "tableSettings": "Licences, Ratings and Medical",
        "hideBackButton": true,
        title() {
            return `Pilot Licence Information`;
        },
        "menuActions": [{
            "label": "Update Licence Information",
            "action": updateLicenceInformation
        }],
        lock(user) {
            return [user?.Role !== "Pilot", "Only pilots can view this area"];
        },
        "dataFields": [{
            "label": "Pilots Licence Number",
            "key": "Licence"
        }, {
            "label": "Licence Authroity",
            "key": "Authority"
        }, {
            "label": "Licences",
            "class": "md:col-span-3",
            compute({ item }) {
                return Object.values(item?.raw?.Licences || {}).join(", ") || "None"
            }
        }, {
            "label": "Ratings Infomation",
            "break": true,
            "class": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Flight Test Rating (Aeroplane)",
            "key": "raw.Ratings.AeroplaneCategory"
        }, {
            "label": "Flight Test Rating (Helicopter)",
            "key": "raw.Ratings.HelicopterCategory"
        }, {
            "label": "Other Ratings",
            "class": "md:col-span-3",
            compute({ item }) {
                return [item?.raw?.Ratings?.Others].flat().map(i => i?.split("_").join(" ")).join(", ") || "None"
            }
        }, {
            "label": "Medical Infomation",
            "break": true,
            "class": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Medical Certificate Number",
            "key": "MedicalNumber"
        }, {
            "label": "Class of Medical Certificate",
            "key": "MedicalClass"
        }, {
            "label": "Medical Certificate Expiry Date",
            "key": "MedicalExpiry",
            "type": "date"
        }]
    }
}];
